module.exports = __webpack_public_path__ + "img/zhongliang.6e9bc041.png";